import * as H from 'history'
import  React from 'react'
import { ClaimModel } from '../../models/ClaimModel'
import { GrantEstimation } from './GrantEstimation'
import { getFY } from '../../shared/Utility'
import { PrintBackButtons } from './controls/PrintBackButtons'

export interface SubmissionPageProps {
    history: H.History
    model: ClaimModel
    autoClaimNumber: string
    onPrint?: { (e: React.MouseEvent): any }
}

export interface SubmissionPageState {
}

export class ApplicationForm1SubmissionPage extends React.Component<SubmissionPageProps, SubmissionPageState> {
  constructor(props: SubmissionPageProps) {
    super(props)
    this.state = {
    }
  }

    close = () => {
      this.props.history.push('/')
    }

    print = (e: React.MouseEvent) => {
      if (this.props.onPrint) { this.props.onPrint(e) } else { window.print() }
    }

    render() {
      return (
        <div>
          <h2 className="mt-3">Submission successful</h2>
          <p><b>{`${this.props.model.abn} - ${this.props.model.registeredNameLocal || this.props.model.registeredName}`}</b></p>
          <p>
            {`Your EMDG Application for the ${getFY(this.props.model.claimYear)} grant year has been received by Austrade.`}
            <br />
            {`Your application form receipt number is: ${this.props.autoClaimNumber}`}
          </p>

          <GrantEstimation model={this.props.model} showSummary={false} />

          <p>
            If you would like to provide feedback about the EMDG scheme,
            <a href="https://www.austrade.gov.au/australian/export/export-grants/assistance/contact/emdg-client-feedback-form" target="_blank" rel="noreferrer">please visit.</a>
          </p>

          <PrintBackButtons onBack={this.close} onPrint={this.print} backLabel="Close" printLabel={this.props.onPrint ? 'Print to pdf' : 'Print'} />
        </div>
      )
    }
}
